export default (slug) => `/regions/${slug}`
